import { FormType } from '../../../form-types';
import { ZaludGeneralQuestionFieldAnswers } from './questions';

const zaludGeneral: FormType<ZaludGeneralQuestionFieldAnswers> = {
  name: 'General',
  questions: [
    {
      key: 'zalud_general_locationTxFl',
      next: {
        condition: { 'zalud_general_locationTxFl.no': true },
        key: 'zalud_general_ineligible',
        els: 'zalud_general_sexAssignedAtBirth'
      }
    },
    {
      key: 'zalud_general_sexAssignedAtBirth',
      next: {
        condition: { 'zalud_general_sexAssignedAtBirth.female': true },
        key: 'zalud_general_pregnant',
        els: 'zalud_general_height'
      }
    },
    'zalud_general_pregnant',
    'zalud_general_breastfeeding',
    'zalud_general_height',
    'zalud_general_weight',
    'zalud_general_medicationAllergies',
    'zalud_general_surgeries',
    'zalud_general_currentMedications',
    'zalud_general_supplements',
    'zalud_general_medicalConditions',
    {
      key: 'zalud_general_conditionsHistory',
      next: {
        condition: { 'zalud_general_conditionsHistory.cancer': true },
        key: 'zalud_general_cancerStatus',
        els: 'zalud_general_tobaccoNicotineUse'
      }
    },
    'zalud_general_cancerStatus',
    'zalud_general_tobaccoNicotineUse',
    'zalud_general_alcoholUse',
    'zalud_general_languagePreference',
    'zalud_general_complete',
    'zalud_general_ineligible'
  ]
};

export default zaludGeneral;
